import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAnalyticalVariableCardContext } from '../AnalyticalVariableCard/AnalyticalVariableCardContext';
import { sectionLabelSx } from '../analyticalVariableCard.constants';

export const AVFormatCard = () => {
  const { analyticalVariable } = useAnalyticalVariableCardContext();
  const intl = useIntl();
  const outputType = analyticalVariable.output?.type;
  const formatLabel = outputType
    ? outputType.charAt(0).toUpperCase() + outputType.slice(1).toLowerCase()
    : null;
  return (
    <Box data-testid="av-detail-format-section" sx={{ mb: 1 }}>
      <Typography variant="body1" sx={sectionLabelSx}>
        {intl.formatMessage({ id: 'projects.analyticalVariables.detailModal.format' })}
      </Typography>
      <Typography id="av-detail-format" data-testid="av-detail-format" variant="body1">
        {formatLabel}
      </Typography>
    </Box>
  );
};
